export const KPI_ACCENTS = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
    'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
    'linear-gradient(135deg, #f6c23e 0%, #fd7e14 100%)',
    'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
];

export const PATIENT_INFORMATION_STATS = [
    { key: 'TOTAL_PATIENTS', label: 'Total Patients', icon: 'bi-people-fill' },
    { key: 'ACTIVE_PATIENTS', label: 'Active Patients', icon: 'bi-person-check' },
    { key: 'PATIENTS_WITH_EMAIL', label: 'With Email', icon: 'bi-envelope' },
    { key: 'PATIENTS_WITH_SMS', label: 'With SMS', icon: 'bi-phone' },
    { key: 'PATIENTS_WITH_PHONE', label: 'With Phone', icon: 'bi-telephone' },
    { key: 'OPTED_FOR_EMAIL', label: 'Opted for Email', icon: 'bi-envelope-check' },
    { key: 'OPTED_FOR_SMS', label: 'Opted for SMS', icon: 'bi-chat-dots' },
];

export const RETURN_ON_INVESTMENT_STATS = [
    { key: 'CONFIRMED_APPOINTMENTS_LAST_30_DAYS', label: 'Confirmed Appointments', icon: 'bi-calendar-check' },
    { key: 'REPUTATION_FEEDBACK_RECEIVED', label: 'Reputation Feedback', icon: 'bi-emoji-smile' },
    { key: 'REPUTATION_COMMENTS_RECEIVED', label: 'Comments Received', icon: 'bi-chat-left-text' },
];

export const EMAIL_STATS_WINDOWS = [
    { days: 30, label: '30 days' },
    { days: 60, label: '60 days' },
    { days: 90, label: '90 days' },
];

export const EMAIL_STATS_CATEGORIES = [
    { keyPrefix: 'EMAIL_APPOINTMENT_REMINDER', label: 'Appointment Reminders' },
    { keyPrefix: 'EMAIL_ARTICLE', label: 'Articles' },
    { keyPrefix: 'EMAIL_GL_PICKUP', label: 'Glass Pickups' },
    { keyPrefix: 'EMAIL_CL_PICKUP', label: 'Contact Lens Pickups' },
    { keyPrefix: 'EMAIL_RECALL_REMINDER', label: 'Recall Reminders' },
    { keyPrefix: 'EMAIL_SURVEY_INVITE', label: 'Survey Invites' },
    { keyPrefix: 'EMAIL_THANK_YOU', label: 'Thank You Emails' },
    { keyPrefix: 'EMAIL_BIRTHDAY', label: 'Birthday Emails' },
];

export const SMS_STATS_CATEGORIES = [
    { keyPrefix: 'SMS_APPOINTMENT_REMINDER', label: 'Appointment Reminders' },
    { keyPrefix: 'SMS_BIRTHDAY', label: 'Birthday' },
    { keyPrefix: 'SMS_PICKUP', label: 'Pickups' },
    { keyPrefix: 'SMS_RECALL_REMINDER', label: 'Recall Reminders' },
    { keyPrefix: 'SMS_THANK_YOU', label: 'Thank You' },
];

export const buildStatsMap = (stats = []) =>
    stats.reduce((acc, stat) => {
        if (stat?.statsName) {
            acc[stat.statsName] = stat.statsValue ?? '0';
        }
        return acc;
    }, {});

export const getLatestStatTimestamp = (stats = []) => {
    if (!stats.length) {
        return null;
    }

    const timestamps = stats
        .map((stat) => stat.modifiedAt || stat.createdAt)
        .filter(Boolean)
        .sort()
        .reverse();

    return timestamps[0] || null;
};
